import { useContext } from 'react';
import { CurrentUserContext, CurrentUserContextType } from '../context/current-user.context';

const useCurrentUser = (): CurrentUserContextType => {
    const state = useContext(CurrentUserContext);
    return state;
};

export default useCurrentUser;
